import { useTranslation } from 'react-i18next';
import {
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';

const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'km', label: 'ភាសាខ្មែរ', flag: '🇰🇭' },
] as const;

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language || 'en';

  return (
    <>
      {LANGUAGES.map(({ code, label, flag }) => (
        <DropdownMenuItem
          key={code}
          onClick={() => changeLanguage(code)}
          className="cursor-pointer"
        >
          <span className="mr-2 text-lg leading-none" aria-hidden>
            {flag}
          </span>
          {label} {currentLanguage === code && '✓'}
        </DropdownMenuItem>
      ))}
    </>
  );
}
